module.exports = __webpack_public_path__ + "static/media/proj19_img3.fd8d2616.jpg";